import { getStaticPathsForLocales } from '../../../../../features/app/pages/domain/use-cases/getStaticPathsForLocales';
import { FullAmendPaymentPage } from '../../../../../features/parking/ui/booking-pages/full-amend/FullAmendPaymentPage';

export const getStaticPaths = getStaticPathsForLocales;

export const getStaticProps = () => ({ props: {} });

export default FullAmendPaymentPage;
